import { Upload as UploadEixo } from '@tmov/design-system';
import { WaveVariantD } from '@tmov/design-system/icons';
import { notification } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import { useListaDocumentosContext } from '../../../../../../../../../contexts/ListaDocumentos';
import apiNetCore from '../../../../../../../../../services/apiNetCore';
import { IconContainer, LoadingContainer } from '../BaixarTodosButton/styles';

const { CancelToken } = axios;
let cancel;

function UploadDocumento({
  fileDefault,
  idDocumnetoDefault,
  tipoDocumento,
  protocolo,
}) {
  const [progress, setProgress] = useState(idDocumnetoDefault ? 1 : 0);
  const [error, setError] = useState(false);
  const [fileInfo, setFileInfo] = useState(fileDefault);
  const [idDocumneto, setIdDocumento] = useState(idDocumnetoDefault);
  const [loading, setLoading] = useState(false);
  const {
    addDocumentoAction,
    loadingDocumentoAction,
    removeDocumentoAction,
    editDocumentoAction,
  } = useListaDocumentosContext();

  const cleanFile = () => {
    setFileInfo(null);
    setIdDocumento(null);
  };

  const handleDelete = useCallback(async () => {
    try {
      setLoading(true);
      loadingDocumentoAction(tipoDocumento, true);
      await apiNetCore.delete(`documento/${protocolo}/${idDocumneto}`);

      removeDocumentoAction(tipoDocumento, idDocumneto);
      cleanFile();
    } catch (_) {
      notification.warning({
        message: 'Ops, não foi possível deletar o documento.',
        description:
          'Caso o problema persista, entre em contato com nosso suporte.',
      });
    } finally {
      loadingDocumentoAction(tipoDocumento, false);
      editDocumentoAction(tipoDocumento);
      setLoading(false);
    }
  }, [
    editDocumentoAction,
    idDocumneto,
    loadingDocumentoAction,
    protocolo,
    removeDocumentoAction,
    tipoDocumento,
  ]);

  const handleUpload = useCallback(
    file => {
      setFileInfo(file);
      setError(false);
      loadingDocumentoAction(tipoDocumento, true);

      const formData = new FormData();
      formData.append('TipoDocumento', tipoDocumento);
      formData.append('Protocolo', protocolo);
      formData.append('Arquivo', file);

      apiNetCore
        .post('/documento/documento-emissao', formData, {
          cancelToken: new CancelToken(c => {
            cancel = c;
          }),
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: event => {
            const progressAxios = event.loaded / event.total;
            setProgress(progressAxios - 0.05);
          },
        })
        .then(({ data }) => {
          setProgress(1);
          cleanFile();
          addDocumentoAction(tipoDocumento, data.protocolo);
        })
        .catch(() => setError(true))
        .finally(() => {
          loadingDocumentoAction(tipoDocumento, false);
        });
    },
    [addDocumentoAction, loadingDocumentoAction, protocolo, tipoDocumento]
  );

  const handleOnChange = async file => {
    if (!file && idDocumneto) {
      handleDelete();
    } else if (!file && error) {
      cleanFile();
    } else if (!file) {
      cancel('Operation canceled by the user.');
    } else if (file) {
      handleUpload(file);
    }
  };

  return (
    <>
      {loading && (
        <LoadingContainer>
          <div>Removendo</div>
          <IconContainer>
            <WaveVariantD size="16px" />
          </IconContainer>
        </LoadingContainer>
      )}
      {!loading && (
        <UploadEixo
          file={fileInfo}
          uploadProgress={progress}
          onChange={handleOnChange}
          error={error}
        />
      )}
    </>
  );
}

UploadDocumento.propTypes = {
  idDocumnetoDefault: PropTypes.string,
  fileDefault: PropTypes.shape(PropTypes.File),
  protocolo: PropTypes.string.isRequired,
  tipoDocumento: PropTypes.number.isRequired,
};

UploadDocumento.defaultProps = {
  idDocumnetoDefault: null,
  fileDefault: null,
};

export default UploadDocumento;
